module.exports = __webpack_public_path__ + "media/images/favicons/32x32-505436e6276060ef9c4d21f36f7bb23e.png";